import { call, put, select } from 'redux-saga/effects';
import { addItemRequest, getItemsRequest, updateItemRequest } from '../../spItems/api';
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from 'src/api/config';
import { getReportFactory, getReportFactorySuccess } from '../actions';
import { getDefaultSaga } from './getDefaultSaga';
import { updateDefaultSaga } from 'src/modules/spItems/sagas/updateDefaultSaga';
import { addDefaultSaga } from 'src/modules/spItems/sagas/addDefaultSaga';
import { actionsVPO, VPOInconsistences } from 'src/pages/DashboardPage/vpo/api/vpo.config';
import { ContentTypeIdDirectory, ContentTypeIdGroupRequirement, ContentTypeIdRequirement, idsGroups } from '../api/config';

export function* getReportFactorySaga({ payload }: any) {
  try {
    if (payload) {

      const { column, columnBlockFactory, dataTable, reportFactory, groupPlanAction, monthFactory, responsible, subdivisionFactory, yearFactory } = payload;

      let month = monthFactory;
      let year = yearFactory;
      let subdivision = subdivisionFactory;
      let factory = reportFactory;
      let columnBlock = columnBlockFactory;

      let response_requirements : unknown = null;
      let filters_requirements : any = {
        ContentTypeId: '^' + ContentTypeIdRequirement,
      };

      if(
        column.selectedIds.length > 0 &&
        groupPlanAction.selectedIds.length > 0
      ){
        // filters_requirements.FileRef = '*' + column.selectedIds[0] + '_.000/' + groupPlanAction.selectedIds[0] + '_.000';
        filters_requirements.FileRef = column.selectedIds.map((idColumn: any) => idsGroups[groupPlanAction.selected[0]][idColumn] && '*' + idColumn + '_.000/' + idsGroups[groupPlanAction.selected[0]][idColumn].groupId + '_.000')
      }

      response_requirements = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        // contentType: 'Requirement',
        filtersType: 'and',
        filters: filters_requirements,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      console.log('response_requirements');

      let response_group_requirements: unknown = null;
      let filters_group_requirements: any = {
        ContentTypeId: '^' + ContentTypeIdGroupRequirement,
      };

      if(
        column.selectedIds.length > 0 && groupPlanAction.selectedIds.length > 0
      ){
        // filters_group_requirements.FileRef = '*' + column.selectedIds[0] + '_.000/' + groupPlanAction.selectedIds[0] + '_.000';
        filters_requirements.FileRef = column.selectedIds.map((idColumn: any) => idsGroups[groupPlanAction.selected[0]][idColumn] && '*' + idColumn + '_.000/' + idsGroups[groupPlanAction.selected[0]][idColumn].groupId + '_.000')
      }

      if(factory.selectedIds.length > 0){
        filters_group_requirements.Factory = factory.selectedIds;
      }

      response_group_requirements = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        // filtersType: 'and',
        filters: filters_group_requirements,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      let response_directory: unknown = null;
      let filters_directory: any = {
        ContentTypeId: '^' + ContentTypeIdDirectory,
      };

      if(
        column.selectedIds.length > 0
      ){
        filters_directory.FileRef = column.selectedIds.map((idColumn: any) => '*VPOColumns/' + idColumn + '_.000');
        // filters_directory.FileRef = '*VPOColumns/' + column.selectedIds[0] + '_.000';
      }

      response_directory = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        contentType: 'Directory',
        filtersType: 'and',
        filters: filters_directory,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      let response_status: unknown = null;
      let filters_status: any = {
        Status: [1,2]
      };
      if(responsible.selected.length > 0){
        filters_status.Author = responsible.selected;
      }
      if(column.selectedIds.length > 0){
        // filters_status.ColumnID = '*' + column.selectedIds[0];
        filters_status.ColumnID = column.selectedIds.map((idColumn: any) => '*' + idColumn);
      }
      if(groupPlanAction.selected.length > 0){
        filters_status.GroupTitle = '*' + groupPlanAction.selected[0];
      }
      if(factory.selectedIds.length > 0){
        filters_status.FactoryID = factory.selectedIds.map(item => '' + item );
      }
      if(month.selectedIds.length > 0){
        filters_status.Month = month.selectedIds.map(item => '' + item);
      }
      if(year.selected.length > 0){
        filters_status.Year = year.selected.map(item => '' + item);
      }
      console.log('filters_status', filters_status);
      response_status = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        // contentType: 'VPOStatusQuestionnaire',
        // filtersType: 'and',
        filters: filters_status
      })

      console.log('response_status', response_status);

      let response_conditions: any = {
        items: [],
        count: 0
      };
      let filters_conditions: any = {};

      let fileRefs:any = [];

      if(column.selectedIds.length > 0 && groupPlanAction.selectedIds.length > 0){
        // /Lists/VPOColumns/22_.000/24_.000/352_.000

        if(response_group_requirements && response_group_requirements.items && response_group_requirements.items.length > 0){

          column.selectedIds.forEach((idColumn: any) => {
            let groupLink = '';

            let filterGroupLink = response_group_requirements.items.filter(item => item.FileRef.indexOf('/Lists/VPOColumns/'+idColumn+'_.000/') >= 0);

            if(filterGroupLink && filterGroupLink.length > 0){
              filterGroupLink.forEach((el: any) => {
                groupLink = el.FileRef;

                if(groupLink !== ''){
                  fileRefs.push(groupLink);
                }
              })
            }
          })

          // filters_conditions.GroupRequirementFileRef = fileRefs;
        }
        // filters_conditions.GroupRequirementFileRef = column.selectedIds.map(
        //   (idColumn: any) => 
        //     idsGroups[groupPlanAction.selected[0]][idColumn] && '/Lists/VPOColumns/' + 
        //     idColumn + 
        //     '_.000/' + 
        //     idsGroups[groupPlanAction.selected[0]][idColumn].groupId + '_.000'
        //   )
      } 
      let filter_months = ['1','2','3','4','5','6','7','8','9','10','11','12'];
      if(month.selectedIds.length > 0){
        filter_months = month.selectedIds.map(item => '' + item);
      }
      

      // Фильтры для года и фабрики теперь обрабатываются в циклах ниже

      function* fetchPage(monthChunk?: string[], yearChunk?: string[], factoryChunk?: string[], nextPage?: any): Generator<any, any, any> {
        const currentFilters: any = {};
        
        // Добавляем месяцы из текущей части
        if (monthChunk && monthChunk.length > 0) {
          currentFilters.Month = monthChunk;
        }
        
        // Добавляем годы из текущей части
        if (yearChunk && yearChunk.length > 0) {
          currentFilters.Year = yearChunk;
        }
        
        // Добавляем фабрики из текущей части
        if (factoryChunk && factoryChunk.length > 0) {
          currentFilters.FactoryID = factoryChunk;
        }

        console.log('filters_conditions', currentFilters, column.selectedIds, response_group_requirements);

        const response = yield call<any>(getDefaultSaga, {
          listName: VPORequirementsConditionsListName,
          // contentType: VPORequirementsConditionsListName,
          filters: currentFilters,
          filtersType: "and",
          rowLimit: 4999, // Ограничиваем количество записей
          ...(nextPage && { nextPage })
        });

        if (!response) return null;

        if (response.nextPage) {
          const nextPageData = yield fetchPage(monthChunk, yearChunk, factoryChunk, response.nextPage);
          return {
            items: [...response.items, ...(nextPageData?.items || [])],
            count: response.items.length + (nextPageData?.count || 0)
          };
        }

        return {
          items: response.items,
          count: response.items.length
        };
      }

      // Подготавливаем массивы для разбиения
      let filter_years = year.selectedIds.length > 0 ? year.selectedIds.map(item => '' + item) : ['2025'];
      let filter_factories = factory.selectedIds.length > 0 ? factory.selectedIds.map(item => '' + item) : ['1'];

      // Выполняем запросы для каждой комбинации месяц-год-фабрика
      let response_conditions_all: any = { items: [], count: 0 };

      for (const monthValue of filter_months) {
        for (const yearValue of filter_years) {
          for (const factoryValue of filter_factories) {
            console.log('Processing:', { month: monthValue, year: yearValue, factory: factoryValue });
            const response: any = yield fetchPage([monthValue], [yearValue], [factoryValue]);
            if (response && response.items) {
              response_conditions_all.items = [...response_conditions_all.items, ...response.items];
              response_conditions_all.count += response.count;
            }
          }
        }
      }

      if(response_conditions_all && response_conditions_all.items && response_conditions_all.items.length > 0){

        response_conditions_all.items.forEach(item=>{
          if(fileRefs.indexOf(item.GroupRequirementFileRef) >= 0){
            response_conditions.items.push(item);
          }
        })

        // response_conditions.items = response_conditions_all.items.map(item => fileRefs.filter(fileRef => fileRef === item.GroupRequirementFileRef).length >= 0 && item);
        response_conditions.count = response_conditions.items.length;

      }

      console.log('response_conditions', response_conditions);

      

      let response_subdivisions: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOsubdivision'
      })


      let response_default_conditions: unknown = null;
      let filters_default_conditions: any = {
        Condition: 'Lock',
      };

      if(
        groupPlanAction.selected.length > 0
      ){
        filters_default_conditions.FileRef = '*/' + groupPlanAction.selected[0];
      }

      response_default_conditions = yield call<any>(getDefaultSaga, {
        listName: 'VPODefaultRequirementConditions',
        recursiveAll: true,
        filtersType: 'and',
        filters: filters_default_conditions
      });

      yield put(
        getReportFactorySuccess({
          response_requirements,
          response_group_requirements,
          response_directory,
          response_status,
          response_conditions,
          response_subdivisions,
          response_default_conditions,
          filters: {
            column,
            columnBlock,
            dataTable,
            factory,
            groupPlanAction,
            month,
            responsible,
            subdivision,
            year
          }
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
